import React, { Component } from "react";
import { Button, Container, Row, Form, Col, Offcanvas,
  Spinner,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from "../config.json";
import { ValidationUtils } from "../Sidebar/Common";

import LoadingOverlay from "./LoadingOverlay";
export default class Widget_instances extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      isSubmitting: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      touched: {}, // Track which fields have been touched
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.widget_instances_Id,
          sortable: true,
          cell: (row) => <span>{row.widget_instances_Id}</span>,
        },
        {
          name: "Instance Name",
          selector: (row, i) => row.instanceName,
          sortable: true,
          cell: (row) => <span>{row.instanceName}</span>,
        },
        {
          name: "widgetTypesId",
          selector: (row, i) => row.widget_types_Id,
          sortable: true,
          cell: (row) => <span>{row.widget_types_Id}</span>,
        },
        {
          name: "Api End Point",
          selector: (row, i) => row.apiEndpoint,
          sortable: true,
          cell: (row) => <span>{row.apiEndpoint}</span>,
        },
        {
          name: "Api Method",
          selector: (row, i) => row.apiMethod,
          sortable: true,
          cell: (row) => <span>{row.apiMethod}</span>,
        },
        {
          name: "Api Params",
          selector: (row, i) => row.apiParams,
          sortable: true,
          cell: (row) => <span>{row.apiParams}</span>,
        },
        {
          name: "Columns Config",
          selector: (row, i) => row.columnsConfig,
          sortable: true,
          cell: (row) => <span className="ellipsis-text">{row.columnsConfig}</span>,
        },
        {
          name: "Actions Config",
          selector: (row, i) => row.actionsConfig,
          sortable: true,
          cell: (row) => <span className="ellipsis-text">{row.actionsConfig}</span>,
        },
        {
          name: "Table Conifg",
          selector: (row, i) => row.tableConfig,
          sortable: true,
          cell: (row) => <span className="ellipsis-text">{row.tableConfig}</span>,
        },
        {
          name: "Form Config",
          selector: (row, i) => row.formConfig,
          sortable: true,
          cell: (row) => <span className="ellipsis-text">{row.formConfig}</span>,
        },
        {
          name: "Chart Config",
          selector: (row, i) => row.chartConfig,
          sortable: true,
          cell: (row) => <span className="ellipsis-text">{row.chartConfig}</span>,
        },
        {
          name: "Filter Config",
          selector: (row, i) => row.filterConfig,
          sortable: true,
          cell: (row) => <span className="ellipsis-text">{row.filterConfig}</span>,
        },
        {
          name: "Custom Props",
          selector: (row, i) => row.customProps,
          sortable: true,
          cell: (row) => <span className="ellipsis-text">{row.customProps}</span>,
        },
        {
          name: "Source Table",
          selector: (row, i) => row.sourceTable,
          sortable: true,
          cell: (row) => <span>{row.sourceTable}</span>,
        },
        {
          name: "Is Active",
          selector: (row, i) => row.isActive,
          sortable: true,
          cell: (row) => <span>{row.isActive}</span>,
        },
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.Widget_instanceseditHandler(row)}
                className="bi bi-pen"
              ></Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              ></Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 100,
      isEditing: false,
      widget_instances_Id: "",
      instanceName: "",
      widget_types_Id: "",
      formConfig: "",
      apiEndpoint: "",
      apiMethod: "",
      apiParams: "",
      columnsConfig: "",
      actionsConfig: "",
      tableConfig: "",
      chartConfig:"",
      filterConfig:"",
      customProps:"",
      sourceTable:"",
      isActive:"",
    };
  }

  // Enhanced validation method using Common.js with auto-generated logic
  validateField = (fieldName, value, fieldConfig) => {
    const { inputType, validationOptions } = fieldConfig;
    const fieldDisplayName = fieldConfig.displayName || fieldName;

    let validationResult = { isValid: true, message: "" };

    // Auto-generated validation based on inputType and validationOptions
    switch (inputType.toLowerCase()) {
      case "text":
        if (validationOptions?.isName) {
          validationResult = ValidationUtils.validateName(value);
        } else if (validationOptions?.isAddress) {
          validationResult = ValidationUtils.validateAddress(value);
        } else if (validationOptions?.maxLength) {
          validationResult = ValidationUtils.validateLength(
            value,
            parseInt(validationOptions.maxLength),
            fieldDisplayName,
          );
        } else {
          validationResult = { isValid: true, message: "" };
        }
        break;

      case "mail":
      case "email":
        validationResult = ValidationUtils.validateEmail(value);
        break;

      case "telephone":
      case "phone":
        validationResult = ValidationUtils.validatePhone(value);
        break;

      case "number":
        validationResult = ValidationUtils.validateNumber(
          value,
          fieldDisplayName,
        );
        break;

      case "dob_child":
        validationResult = ValidationUtils.validateDOBMinAge(value);
        break;

      case "dob_adult":
        validationResult = ValidationUtils.validateDOBAdult(value);
        break;

      case "pan":
        validationResult = ValidationUtils.validatePAN(value);
        break;

      case "aadhaar":
        validationResult = ValidationUtils.validateAadhaar(value);
        break;

      case "password":
        if (value.length < 6) {
          validationResult = {
            isValid: false,
            message: "Password must be at least 6 characters long",
          };
        }
        break;

      default:
        validationResult = { isValid: true, message: "" };
    }

    // Check required field validation
    if (
      validationOptions?.isRequired &&
      (!value || value.toString().trim() === "")
    ) {
      validationResult = ValidationUtils.validateRequired(
        value,
        fieldDisplayName,
      );
    }

    const errors = { ...this.state.errors };
    if (!validationResult.isValid) {
      errors[fieldName] = validationResult.message;
    } else {
      delete errors[fieldName];
    }

    this.setState({ errors });
    return validationResult.isValid;
  };

  // Enhanced field change handler with auto-validation
  handleFieldChange = (fieldName, value, fieldConfig) => {
    this.setState({
      [fieldName]: value,
      touched: { ...this.state.touched, [fieldName]: true },
    });

    // Only validate if field has been touched
    if (this.state.touched[fieldName] || value !== "") {
      this.validateField(fieldName, value, fieldConfig);
    }
  };

  // Enhanced field blur handler for validation
  handleFieldBlur = (fieldName, value, fieldConfig) => {
    this.setState({
      touched: { ...this.state.touched, [fieldName]: true },
    });
    this.validateField(fieldName, value, fieldConfig);
  };

  // Check if form is valid - auto-generated based on required fields
  isFormValid = () => {
    const { errors } = this.state;

    // Auto-generated required field validation
    // No required fields defined

    return Object.keys(errors).length === 0;
  };

  // Auto-generated validation for all fields before submission
  validateAllFields = () => {
    const fieldConfigs = [
      {
        fieldName: "instanceName",
        inputType: "Text",
        displayName: "Widget Instance Name",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "widget_types_Id",
        inputType: "Text",
        displayName: "widgetTypesId",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "formConfig",
        inputType: "Text",
        displayName: "Layout Cell Id",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "apiEndpoint",
        inputType: "Text",
        displayName: "Api End Point",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "apiMethod",
        inputType: "Text",
        displayName: "Api Method",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "apiParams",
        inputType: "Text",
        displayName: "Api Params",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "columnsConfig",
        inputType: "Text",
        displayName: "Columns Config",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "actionsConfig",
        inputType: "Text",
        displayName: "Actions Config",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "tableConfig",
        inputType: "Text",
        displayName: "Table Conifg",
        validationOptions: { isRequired: false },
      },
    ];

    fieldConfigs.forEach((config) => {
      const value = this.state[config.fieldName];
      this.validateField(config.fieldName, value, config);
    });

    const touched = {};
    fieldConfigs.forEach((config) => {
      touched[config.fieldName] = true;
    });
    this.setState({ touched });
  };

  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      errors: {},
      touched: {},
      instanceName: "",
      widget_types_Id: "",
      formConfig: "",
      apiEndpoint: "",
      apiMethod: "",
      apiParams: "",
      columnsConfig: "",
      actionsConfig: "",
      tableConfig: "",
      chartConfig:"",
      filterConfig:"",
      customProps:"",
      sourceTable:"",
      isActive:"",
    });
  };

  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({
      show: false,
      isEditing: false,
      errors: {},
      touched: {},
      instanceName: "",
      widget_types_Id: "",
      formConfig: "",
      apiEndpoint: "",
      apiMethod: "",
      apiParams: "",
      columnsConfig: "",
      actionsConfig: "",
      tableConfig: "",
      chartConfig:"",
      filterConfig:"",
      customProps:"",
      sourceTable:"",
      isActive:"",
    });
  };

  // Enhanced toast notifications
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
    }
  };

  Widget_instanceseditHandler = (row) => {
    this.setState({
      isEditing: true,
      show: true,
      widget_instances_Id: row.widget_instances_Id,
      instanceName: row.instanceName,
      widget_types_Id: row.widget_types_Id,
      formConfig: row.formConfig,
      apiEndpoint: row.apiEndpoint,
      apiMethod: row.apiMethod,
      apiParams: row.apiParams,
      columnsConfig: row.columnsConfig,
      actionsConfig: row.actionsConfig,
      tableConfig: row.tableConfig,
      chartConfig:row.chartConfig,
      filterConfig:row.filterConfig,
      customProps:row.customProps,
      sourceTable:row.sourceTable,
      isActive:row.isActive,
      errors: {},
      touched: {},
    });
  };

  Widget_instancesfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "C_Widget_instances/list", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load data", "error");
      });
  };

  Widget_instancessubmitHandler = (e) => {
    e.preventDefault();
    if (this.state.isSubmitting) return;
    this.setState({ isSubmitting: true });

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before submitting", "error");
      this.setState({ isSubmitting: false });
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("instanceName", this.state.instanceName);
    formData.append("widget_types_Id", this.state.widget_types_Id);
    formData.append("formConfig", this.state.formConfig);
    formData.append("apiEndpoint", this.state.apiEndpoint);
    formData.append("apiMethod", this.state.apiMethod);
    formData.append("apiParams", this.state.apiParams);
    formData.append("columnsConfig", this.state.columnsConfig);
    formData.append("actionsConfig", this.state.actionsConfig);
    formData.append("tableConfig", this.state.tableConfig);
    formData.append("chartConfig", this.state.chartConfig);
    formData.append("filterConfig", this.state.filterConfig);
    formData.append("customProps", this.state.customProps);
    formData.append("sourceTable", this.state.sourceTable);
    formData.append("isActive", this.state.isActive);
    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + "C_Widget_instances/add", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Widget_instancesfetchHandler();
          this.handleOffcanvasClose();
          this.setState({
            instanceName: "",
            widget_types_Id: "",
            formConfig: "",
            apiEndpoint: "",
            apiMethod: "",
            apiParams: "",
            columnsConfig: "",
            actionsConfig: "",
            tableConfig: "",
            chartConfig:"",
            filterConfig:"",
            customProps:"",
            sourceTable:"",
            isActive:"",
          });
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      
        this.setState({ loading: false });}).finally(() => this.setState({ isSubmitting: false }));
  };

  Widget_instancesupdateHandler = (e) => {
    e.preventDefault();
    if (this.state.isSubmitting) return;
    this.setState({ isSubmitting: true });
    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before updating", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("widget_instances_Id", this.state.widget_instances_Id);
    formData.append("instanceName", this.state.instanceName);
    formData.append("widget_types_Id", this.state.widget_types_Id);
    formData.append("formConfig", this.state.formConfig);
    formData.append("apiEndpoint", this.state.apiEndpoint);
    formData.append("apiMethod", this.state.apiMethod);
    formData.append("apiParams", this.state.apiParams);
    formData.append("columnsConfig", this.state.columnsConfig);
    formData.append("actionsConfig", this.state.actionsConfig);
    formData.append("tableConfig", this.state.tableConfig);
    formData.append("chartConfig", this.state.chartConfig);
    formData.append("filterConfig", this.state.filterConfig);
    formData.append("customProps", this.state.customProps);
    formData.append("sourceTable", this.state.sourceTable);
    formData.append("isActive", this.state.isActive);
    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + "C_Widget_instances/update", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Widget_instancesfetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Update error:", error);
        this.showToast("Failed to update data", "error");
      
        this.setState({ loading: false });}).finally(() => this.setState({ isSubmitting: false }));
  };

  componentDidMount() {
    this.Widget_instancesfetchHandler();
  }

  handleinstanceNameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ instanceName: fieldValue });
  };
  handlewidget_types_IdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ widget_types_Id: fieldValue });
  };
  handleformConfigChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ formConfig: fieldValue });
  };
  handleapiEndpointChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ apiEndpoint: fieldValue });
  };
  handleapiMethodChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ apiMethod: fieldValue });
  };
  handleapiParamsChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ apiParams: fieldValue });
  };
  handlecolumnsConfigChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ columnsConfig: fieldValue });
  };
  handleactionsConfigChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ actionsConfig: fieldValue });
  };
  handletableConfigChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ tableConfig: fieldValue });
  };
  handlechartConfigChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ chartConfig: fieldValue });
  };
  handlefilterConfigChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ filterConfig: fieldValue });
  };
  handlecustomPropsChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ customProps: fieldValue });
  };
  handlesourceTableChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ sourceTable: fieldValue });
  };
  handleisActiveChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ isActive: fieldValue });
  };

  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
  };

  handleDelete = (row, index) => {
    if (
      !window.confirm(`Are you sure you want to delete this widget_instances?`)
    ) {
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("widget_instances_Id", row.widget_instances_Id);

    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + "C_Widget_instances/delete", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Widget_instancesfetchHandler();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Delete error:", error);
        this.showToast("Failed to delete data", "error");
      
        this.setState({ loading: false });});
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  // Helper method to render error message
  renderFieldError = (fieldName) => {
    const { errors, touched } = this.state;
    if (errors[fieldName] && touched[fieldName]) {
      return (
        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
          <i className="bi bi-exclamation-circle me-1"></i>
          {errors[fieldName]}
        </div>
      );
    }
    return null;
  };

  // Auto-generated form field renderer based on inputType and validation options
  renderFormField = (fieldConfig) => {
    const { fieldName, displayName, inputType, validationOptions } =
      fieldConfig;
    const value = this.state[fieldName] || "";
    const hasError =
      this.state.errors[fieldName] && this.state.touched[fieldName];

    let inputElement;

    switch (inputType.toLowerCase()) {
      case "dob_child":
      case "dob_adult":
      case "date":
        inputElement = (
          <Form.Control
            type="date"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
          />
        );
        break;

      case "telephone":
      case "phone":
        inputElement = (
          <Form.Control
            type="tel"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter 10-digit mobile number"
          />
        );
        break;

      case "mail":
      case "email":
        inputElement = (
          <Form.Control
            type="email"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter email address"
          />
        );
        break;

      case "password":
        inputElement = (
          <Form.Control
            type="password"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter password"
          />
        );
        break;

      case "number":
        inputElement = (
          <Form.Control
            type="number"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
          />
        );
        break;

      case "pan":
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(
                fieldName,
                e.target.value.toUpperCase(),
                fieldConfig,
              )
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="ABCPA1234B"
            maxLength="10"
          />
        );
        break;

      case "aadhaar":
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(
                fieldName,
                e.target.value.replace(/\D/g, ""),
                fieldConfig,
              )
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="123456789012"
            maxLength="12"
          />
        );
        break;

      default: // text and other types
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
            maxLength={validationOptions?.maxLength || undefined}
          />
        );
    }

    return (
      <Row key={fieldName}>
        <Col lg="4" md="4">
          <Form.Label>
            {displayName}
            {validationOptions?.isRequired && (
              <span className="text-danger">*</span>
            )}
          </Form.Label>
        </Col>
        <Col lg="8" md="8">
          {inputElement}
          {this.renderFieldError(fieldName)}
        </Col>
      </Row>
    );
  };

  render() {
    const { errors } = this.state;

    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
          (this.state.currentPage - 1) * this.state.itemsPerPage,
          this.state.currentPage * this.state.itemsPerPage,
        )
      : this.state.data.slice(
          (this.state.currentPage - 1) * this.state.itemsPerPage,
          this.state.currentPage * this.state.itemsPerPage,
        );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3
                        className="logoskybluecolor"
                        style={{ textAlign: "start" }}
                      >
                        Widget Instances
                      </h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      {/* <Button
                variant="primary" style={{ float: "right", marginBottom: "10px" }}
                className="bi bi-plus "
                onClick={this.handleOffcanvasShow}
              >
              New
              </Button> */}

                      {/* Enhanced Add Offcanvas */}
                      <Offcanvas
                        show={this.state.show && !this.state.isEditing}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>
                            Add Widget Instances
                          </Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container
                            style={{ overflowY: "auto", height: "auto" }}
                          >
                            {/* Error Summary */}
                            {Object.keys(errors).length > 0 && (
                              <div className="alert alert-danger mb-3">
                                <strong>
                                  Please fix the following errors:
                                </strong>
                                <ul className="mb-0 mt-2">
                                  {Object.entries(errors).map(
                                    ([field, error]) => (
                                      <li key={field}>{error}</li>
                                    ),
                                  )}
                                </ul>
                              </div>
                            )}
                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Instance Name
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handleinstanceNameChange
                                        }
                                        className="form-control"
                                        name="instanceName"
                                        value={this.state.instanceName}
                                        required="required"
                                        placeholder="Enter Instance Name"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {
                                        this.state.errors.instanceName
                                      }{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        widgetTypesId
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlewidget_types_IdChange
                                        }
                                        className="form-control"
                                        name="widget_types_Id"
                                        value={this.state.widget_types_Id}
                                        required="required"
                                        placeholder="Enter widget_types_Id"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.widget_types_Id}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Api End Point
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handleapiEndpointChange}
                                        className="form-control"
                                        name="apiEndpoint"
                                        value={this.state.apiEndpoint}
                                        required="required"
                                        placeholder="Enter apiEndpoint"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.apiEndpoint}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Api Method
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handleapiMethodChange}
                                        className="form-control"
                                        name="apiMethod"
                                        value={this.state.apiMethod}
                                        required="required"
                                        placeholder="Enter apiMethod"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.apiMethod}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Api Params
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handleapiParamsChange}
                                        className="form-control"
                                        name="apiParams"
                                        value={this.state.apiParams}
                                        required="required"
                                        placeholder="Enter apiParams"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.apiParams}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Columns Config
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlecolumnsConfigChange
                                        }
                                        className="form-control"
                                        name="columnsConfig"
                                        value={this.state.columnsConfig}
                                        required="required"
                                        placeholder="Enter columnsConfig"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.columnsConfig}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Actions Config
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handleactionsConfigChange
                                        }
                                        className="form-control"
                                        name="actionsConfig"
                                        value={this.state.actionsConfig}
                                        required="required"
                                        placeholder="Enter actionsConfig"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.actionsConfig}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Table Conifg
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handletableConfigChange}
                                        className="form-control"
                                        name="tableConfig"
                                        value={this.state.tableConfig}
                                        required="required"
                                        placeholder="Enter tableConfig"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.tableConfig}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Form Config
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handleformConfigChange
                                        }
                                        className="form-control"
                                        name="formConfig"
                                        value={this.state.formConfig}
                                        required="required"
                                        placeholder="Enter Form Config"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.formConfig}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Chart Config
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlechartConfigChange
                                        }
                                        className="form-control"
                                        name="chartConfig"
                                        value={this.state.chartConfig}
                                        required="required"
                                        placeholder="Enter Chart Config"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Filter Config
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlefilterConfigChange
                                        }
                                        className="form-control"
                                        name="filterConfig"
                                        value={this.state.filterConfig}
                                        required="required"
                                        placeholder="Enter Filter Config"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Custom Props
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlecustomPropsChange
                                        }
                                        className="form-control"
                                        name="customProps"
                                        value={this.state.customProps}
                                        required="required"
                                        placeholder="Enter Custom Props"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Source Table
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlesourceTableChange
                                        }
                                        className="form-control"
                                        name="sourceTable"
                                        value={this.state.sourceTable}
                                        required="required"
                                        placeholder="Enter Source Table"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Is Active
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handleisActiveChange
                                        }
                                        className="form-control"
                                        name="isActive"
                                        value={this.state.isActive}
                                        required="required"
                                        placeholder="Enter Is Active"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  {/* tableContent */}
                                  {/* Auto-generated form content with validation */}
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "20px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.Widget_instancessubmitHandler}
                                  disabled={this.state.isSubmitting || !this.isFormValid()}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                        {this.state.isSubmitting ? (<><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />Saving...</>) : "Save"}
                      </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>

                      {/* Enhanced Edit Offcanvas */}
                      {this.state.isEditing && (
                        <Offcanvas
                          show={this.state.isEditing}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>
                              Edit Widget Instances
                            </Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container
                              style={{ overflowY: "auto", height: "auto" }}
                            >
                              {/* Error Summary */}
                              {Object.keys(errors).length > 0 && (
                                <div className="alert alert-danger mb-3">
                                  <strong>
                                    Please fix the following errors:
                                  </strong>
                                  <ul className="mb-0 mt-2">
                                    {Object.entries(errors).map(
                                      ([field, error]) => (
                                        <li key={field}>{error}</li>
                                      ),
                                    )}
                                  </ul>
                                </div>
                              )}

                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Instance Name
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handleinstanceNameChange
                                          }
                                          className="form-control"
                                          name="instanceName"
                                          value={this.state.instanceName}
                                          required="required"
                                          placeholder="Enter Instance Name"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {
                                          this.state.errors.instanceName
                                        }{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          widgetTypesId
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlewidget_types_IdChange
                                          }
                                          className="form-control"
                                          name="widget_types_Id"
                                          value={this.state.widget_types_Id}
                                          required="required"
                                          placeholder="Enter widget_types_Id"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.widget_types_Id}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                     <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Api End Point
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handleapiEndpointChange
                                          }
                                          className="form-control"
                                          name="apiEndpoint"
                                          value={this.state.apiEndpoint}
                                          required="required"
                                          placeholder="Enter apiEndpoint"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.apiEndpoint}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Api Method
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handleapiMethodChange}
                                          className="form-control"
                                          name="apiMethod"
                                          value={this.state.apiMethod}
                                          required="required"
                                          placeholder="Enter apiMethod"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.apiMethod}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Api Params
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handleapiParamsChange}
                                          className="form-control"
                                          name="apiParams"
                                          value={this.state.apiParams}
                                          required="required"
                                          placeholder="Enter apiParams"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.apiParams}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Columns Config
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlecolumnsConfigChange
                                          }
                                          className="form-control"
                                          name="columnsConfig"
                                          value={this.state.columnsConfig}
                                          required="required"
                                          placeholder="Enter columnsConfig"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.columnsConfig}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Actions Config
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handleactionsConfigChange
                                          }
                                          className="form-control"
                                          name="actionsConfig"
                                          value={this.state.actionsConfig}
                                          required="required"
                                          placeholder="Enter actionsConfig"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.actionsConfig}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Table Conifg
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handletableConfigChange
                                          }
                                          className="form-control"
                                          name="tableConfig"
                                          value={this.state.tableConfig}
                                          required="required"
                                          placeholder="Enter tableConfig"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.tableConfig}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Form Config
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handleformConfigChange
                                          }
                                          className="form-control"
                                          name="formConfig"
                                          value={this.state.formConfig}
                                          required="required"
                                          placeholder="Enter Form Config"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.formConfig}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                   <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Chart Config
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlechartConfigChange
                                        }
                                        className="form-control"
                                        name="chartConfig"
                                        value={this.state.chartConfig}
                                        required="required"
                                        placeholder="Enter Chart Config"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Filter Config
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlefilterConfigChange
                                        }
                                        className="form-control"
                                        name="filterConfig"
                                        value={this.state.filterConfig}
                                        required="required"
                                        placeholder="Enter Filter Config"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Custom Props
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlecustomPropsChange
                                        }
                                        className="form-control"
                                        name="customProps"
                                        value={this.state.customProps}
                                        required="required"
                                        placeholder="Enter Custom Props"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Source Table
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlesourceTableChange
                                        }
                                        className="form-control"
                                        name="sourceTable"
                                        value={this.state.sourceTable}
                                        required="required"
                                        placeholder="Enter Source Table"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Is Active
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handleisActiveChange
                                        }
                                        className="form-control"
                                        name="isActive"
                                        value={this.state.isActive}
                                        required="required"
                                        placeholder="Enter Is Active"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                    
                                    {/* tableContent */}
                                    {/* Auto-generated form content with validation */}
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "20px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={this.Widget_instancesupdateHandler}
                                    disabled={this.state.isSubmitting || !this.isFormValid()}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    {this.state.isSubmitting ? (<><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />Updating...</>) : "Update"}
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ marginRight: "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <Button
                        variant="primary"
                        className="bi bi-plus"
                        style={{ float: "right", marginBottom: "10px" }}
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={this.state.itemsPerPage}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
